import { Component, ElementRef, OnInit, Renderer, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../app.service';
import { LoginDto } from '../shared/models/LoginDto';
import { NgForm } from '@angular/forms';
import { SecurityService } from '../core/services/security.service';
import { VerifyOtpLoginRequest } from '../shared/models/Security/verify-otp-login-request';
import { NotificationService } from '../core/services/notification.service';
import { NotificationType } from '../core/services/notification-type';
import { environment } from '../../environments/environment';

@Component({
	selector: 'login',
	templateUrl: './login.page.html',
	styleUrls: [
		'./login.page.scss',
		'../../vendor/styles/pages/authentication.scss',
		'../../vendor/libs/angular2-ladda/angular2-ladda.scss'
	]
})
export class LoginPage implements OnInit {

	@ViewChild('loginForm') loginForm: NgForm;
	@ViewChild('otpCodeInput') otpCodeInput: ElementRef;

	credentials: LoginDto = new LoginDto();
	returnUrl: string;
	error = '';
	dataLoading = false;
	tokenHasExpired: boolean = false;

	showOtpControl: boolean = false;
	verificationModel: VerifyOtpLoginRequest = null;
	otpPendingToken: string;

	constructor(private appService: AppService,
		private securityService: SecurityService,
		private router: Router,
		private route: ActivatedRoute,
		private notificationService: NotificationService) {
		this.appService.pageTitle = 'Вход';
	}

	ngOnInit() {
		this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
		this.tokenHasExpired = this.route.snapshot.queryParamMap.get('tokenHasExpired') === "true";

		if (this.tokenHasExpired){
			this.error = "Истекло время сессии";
		}
	}

	signIn() {
		this.error = '';
		this.dataLoading = true;

		if (this.showOtpControl) {
			this.verifyOtpLogin();
			return;
		}
		
		if (this.loginForm.invalid) {
			this.appService.MarkFormDirty(this.loginForm);
			return;
		}

		if (environment.enableOtpAuthentication == 'true') {
			this.securityService.enableOtpLogin(this.credentials).subscribe(res => {
				this.dataLoading = false;

				if (res.isSuccessful) {
					this.showOtpControl = true;
					this.verificationModel = {
						otpPendingToken: res.data.pendingToken,
						otpCode: null
					} as VerifyOtpLoginRequest;

					setTimeout(() => this.otpCodeInput.nativeElement.focus());
				}
				else {
					this.error = res.errorDescription;
				}
			}, x => {
				this.dataLoading = false;
				this.error = x.errorDescription;
			});
		}
		else {
			this.securityService.login(this.credentials).subscribe(res => {
				this.dataLoading = false;

				if (res.isSuccessful){
					this.router.navigateByUrl(this.returnUrl && this.returnUrl !== '/' ? this.returnUrl : 'requests');
				} else {
					this.error = res.errorDescription;
				}

			}, x => {
				this.dataLoading = false;
				this.error = x.errorDescription;
			});
		}
	}

	verifyOtpLogin() {
		this.securityService.verifyOtpLogin(this.verificationModel).subscribe(res => {
			this.dataLoading = false;

			if (res.isSuccessful) {
				if (res.data.otpCodeIsValid) {
					this.router.navigateByUrl(this.returnUrl && this.returnUrl !== '/' ? this.returnUrl : 'requests');
				}
				else if (res.data.otpPendingTokenIsExpired) {
					this.notificationService.error({ 
						message: 'Время для ввода OTP-кода вышла. Повторите попытку', 
						title: "Ошибка авторизации", 
						notificationType: NotificationType.Toast 
					});

					this.showOtpControl = false;
					this.credentials = new LoginDto();
				}
				else {
					this.error = "Неккоректный OTP-код";
				}
			}
			else {
				this.error = res.errorDescription;
			}
		}, x => {
			this.dataLoading = false;
			this.error = x.errorDescription;
		});
	}

	cancelOtpControl() {
		this.showOtpControl = false;
		this.otpPendingToken = null;
	}

	isEmpty(value: string) {
		return value == null || value.trim() == '';
	}
}
